import apiService from './api.service';

export interface VideoUploadResult {
  blob_name: string;
  filename: string;
  size_bytes: number;
  content_type: string;
}

export interface VideoUrlResult {
  url: string;
  expires_at: string | null;
}

// O default do axios (30 s, VITE_API_TIMEOUT) abortava o upload no meio do
// corpo: 400 MB em 30 s exigiria ~107 Mbps sustentados. O teto prático medido
// era ~60 MB. O 4º parâmetro de uploadFile já existia e já era usado pelo
// assistant.service — o upload de vídeo é que não o passava.
const VIDEO_UPLOAD_TIMEOUT_MS = 30 * 60_000; // 30 min

class VideoService {
  async uploadVideo(
    file: File,
    onProgress?: (percent: number) => void
  ): Promise<VideoUploadResult> {
    const { data } = await apiService.uploadFile<VideoUploadResult>(
      '/upload/video/',
      file,
      onProgress
        ? (event: unknown) => {
            const e = event as { loaded?: number; total?: number };
            if (e.total) {
              onProgress(Math.round((e.loaded! / e.total) * 100));
            }
          }
        : undefined,
      VIDEO_UPLOAD_TIMEOUT_MS
    );
    return data;
  }

  async uploadVideoThumbnail(file: File): Promise<{ url: string; filename: string }> {
    const { data } = await apiService.uploadFile<{ url: string; filename: string }>(
      '/upload/video-thumbnail/',
      file
    );
    return data;
  }

  async getVideoUrl(lessonId: string): Promise<VideoUrlResult> {
    const { data } = await apiService.get<VideoUrlResult>(
      `/lessons/${lessonId}/video-url/`
    );
    return data;
  }

  async reportProgress(
    lessonId: string,
    percent: number,
    timeSeconds: number
  ): Promise<void> {
    await apiService.post(`/lessons/${lessonId}/video-progress/`, {
      percent,
      time_seconds: timeSeconds,
    });
  }

  async deleteVideo(lessonId: string): Promise<void> {
    await apiService.delete(`/admin/lessons/${lessonId}/video/`);
  }
}

export const videoService = new VideoService();
